if (!customElements.get("m-icon-box-service-qa")) {
    class MIconbox extends HTMLElement {
        constructor() {
          super();

          this.enableSlider = this.dataset.enableSlider === "true";
          this.items = this.dataset.items;
          this.showPagination = this.dataset.showPagination === "true";
          this.showNavigation = this.dataset.showNavigation === "true";
          this.slideContainer = this.querySelector(".swiper-container");
        }

        connectedCallback() {
            this.lastActive = null; 
            console.log("initClassification");
            this.initClassification();
            this.initQA();
        } 

        initQA(){ 
  const blocks = Array.from(document.querySelectorAll('.sq-bottom-block'));

    function  closeBlock(block) {
    block.classList.remove('is-open');
    const answer = block.querySelector('.sq-bottom-block-answer');
    if (!answer) return;
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';
  }

   function  openBlock(block) {
    block.classList.add('is-open');
    const answer = block.querySelector('.sq-bottom-block-answer');
    if (!answer) return;

    // 先歸零再量高度，確保動畫正常
    answer.style.maxHeight = '0px';
    answer.style.opacity = '1';
    const h = answer.scrollHeight+20;
    answer.style.maxHeight = h + 'px';
  }
  // ✅ 一開始先全部隱藏（無視你原本 inline display）
  blocks.forEach(closeBlock);

  blocks.forEach(block => {
    const q = block.querySelector('.sq-bottom-block-question');
    const a = block.querySelector('.sq-bottom-block-answer');
    if (!q || !a) return;

    q.addEventListener('click', () => {
      const isOpen = block.classList.contains('is-open');

      // 先把其他全部關起來
      blocks.forEach(b => {
        if (b !== block) this.closeBlock(b);
      });

      // 再切換目前這個
      if (isOpen) {
        this.closeBlock(block);
      } else {
        this.openBlock(block);
      }
    });
  });

  // 視窗 resize 時，校正已展開的高度
  window.addEventListener('resize', () => {
    blocks.forEach(block => {
            if (!block.classList.contains('is-open')) return;
            const answer = block.querySelector('.sq-bottom-block-answer');
            if (!answer) return;
            answer.style.maxHeight = answer.scrollHeight + 'px';
          });
        });
        }


    closeBlock(block) {
    block.classList.remove('is-open');
    const answer = block.querySelector('.sq-bottom-block-answer');
    if (!answer) return;
    answer.style.maxHeight = '0px';
    answer.style.opacity = '0';
  }

    openBlock(block) {
    block.classList.add('is-open');
    const answer = block.querySelector('.sq-bottom-block-answer');
    if (!answer) return;

    // 先歸零再量高度，確保動畫正常
    answer.style.maxHeight = '0px';
    answer.style.opacity = '1';
    const h = answer.scrollHeight+20;
    answer.style.maxHeight = h + 'px';
  }

        initClassification() {
            console.log("initClassification");
            const root = document.querySelector(".serviceQA");
            if (!root) return;

            const classButtons = root.querySelectorAll(".sq-top-classification");
            const blocks1 = root.querySelectorAll(".sq-top-classification");
            const blocks2 = root.querySelectorAll(".sq-bottom-block");
            const content = root.querySelectorAll(".sq-bottom-content");

            if (classButtons.length === 0) return;

            // 取得第一個分類的 ID
            const firstID = classButtons[0].dataset.classificationId;

            // ----- 預設啟動 -----
            this.applyClassification(firstID, classButtons, blocks1, blocks2,content);

            // ----- 綁定點擊事件 -----
            classButtons.forEach(btn => {
                btn.addEventListener("click", () => {
                const targetID = btn.dataset.classificationId;
                this.applyClassification(targetID, classButtons, blocks1, blocks2,content);
                });
            });
        }

        applyClassification(id, classButtons, blocks1, blocks2,content) {
            // 切換 active 樣式
            classButtons.forEach(btn => {
                btn.classList.toggle("active", btn.dataset.classificationId === id);
            });

            // 顯示/隱藏第二區塊
            // blocks1.forEach(block => {
            //     block.style.display = (block.dataset.blockId === id) ? "flex" : "none";
            // });

            blocks2.forEach(block => {
                block.style.display = (block.dataset.blockId === id) ? "block" : "none";
            });
            content.forEach(block => {
                block.style.display = (block.dataset.blockId === id) ? "block" : "none";
            });

            // 把該分類下「第一個可見 block」預設打開（可按需求改）
            const firstVisible = Array.from(blocks2)
              .find(b => b.dataset.blockId === id);

            // 先把所有 block 收起來（避免高度殘留）
            blocks2.forEach(b => this.closeBlock(b));
            setTimeout(() => {
              if (firstVisible) this.openBlock(firstVisible); 
            }, 400); 
        }


       
    }
    customElements.define("m-icon-box-service-qa", MIconbox);
}